/* MW-20261101-13 · Rise2Hope: no size is preselected. Add to cart and express checkout stay disabled until the shopper picks a size. */
(function () {
  if (new URLSearchParams(location.search).has('variant')) return;
  var chosen = false;
  var LABEL = 'Select a size';
  function sizeFieldset() {
    var legends = document.querySelectorAll('variant-picker fieldset legend');
    for (var i = 0; i < legends.length; i++) {
      if (/^\s*size/i.test(legends[i].textContent)) return legends[i].closest('fieldset');
    }
    return null;
  }
  function buttons() { return document.querySelectorAll('form[action*="/cart/add"] .add-to-cart-button, .sticky-add-to-cart__button'); }
  function addGuideLink(fs) {
    var legend = fs.querySelector('legend');
    if (!legend || legend.querySelector('.r2h-size-guide')) return;
    var a = document.createElement('a');
    a.href = '#';
    a.className = 'r2h-size-guide';
    a.textContent = 'Size guide';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var sums = document.querySelectorAll('summary');
      for (var i = 0; i < sums.length; i++) {
        if (/size guide/i.test(sums[i].textContent)) {
          var d = sums[i].closest('details');
          if (d && !d.open) sums[i].click();
          sums[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
    });
    legend.appendChild(a);
  }
  function apply() {
    var fs = sizeFieldset();
    if (!fs) return;
    addGuideLink(fs);
    if (chosen) return;
    document.documentElement.classList.add('r2h-size-pending');
    fs.querySelectorAll('input[type="radio"]').forEach(function (i) { if (i.checked) i.checked = false; });
    buttons().forEach(function (b) {
      if (!b.disabled) b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      var t = b.querySelector('.add-to-cart-text__content > span');
      if (t && t.textContent.trim() !== LABEL) { t.dataset.r2hOriginal = t.textContent; t.textContent = LABEL; }
    });
  }
  function release() {
    chosen = true;
    document.documentElement.classList.remove('r2h-size-pending');
    buttons().forEach(function (b) {
      b.disabled = false;
      b.removeAttribute('aria-disabled');
      var t = b.querySelector('.add-to-cart-text__content > span');
      if (t && t.dataset.r2hOriginal) { t.textContent = t.dataset.r2hOriginal; delete t.dataset.r2hOriginal; }
    });
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!chosen && el && el.type === 'radio' && /^Size-/i.test(el.name || '')) release();
  }, true);
  document.addEventListener('submit', function (e) {
    if (!chosen && e.target && /\/cart\/add/.test(e.target.getAttribute('action') || '')) { e.preventDefault(); e.stopImmediatePropagation(); apply(); }
  }, true);
  document.addEventListener('click', function (e) {
    if (chosen) return;
    var b = e.target && e.target.closest && e.target.closest('.add-to-cart-button, .sticky-add-to-cart__button, .accelerated-checkout-block');
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); var fs = sizeFieldset(); if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, true);
  function start() {
    apply();
    var root = document.querySelector('main') || document.body;
    new MutationObserver(function () { if (!chosen) apply(); else { var fs = sizeFieldset(); if (fs) addGuideLink(fs); } }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
